export const NODE_TYPES = {
    IMAGE: 'image',
    TEXT: 'text',
    SVG_SHAPE: 'svg-shape',
}
